import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
// import { textStyle } from "src/styles/textstyle";
import ContentBox from "src/components/ContentBox/ContentBox";
import { aboutUs } from "src/media/texts/aboutUs";
import earth from "src/media/earth.jpg";

export default function StillUnsure() {
  return (
    <ContentBox id="about-us">
      <Grid container spacing={5}>
        <Grid item xs={12} md={6}>
          <div
            style={{
              position: "relative",
              paddingBottom: "56.25%",
              height: 0,
              overflow: "hidden",
              maxWidth: "100%",
            }}
          >
            <img
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover", // Ensure the image covers the container while maintaining aspect ratio
                borderRadius: "12px",
              }}
              src={earth} // Replace with the URL of your image
              alt="A globe representing HomeSwap's global community and international home exchange opportunities."
            />
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h3"
            sx={{ textAlign: "left", fontWeight: "bold" }}
          >
            About us
          </Typography>
          <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
            {aboutUs}
          </Typography>
        </Grid>
      </Grid>
    </ContentBox>
  );
}
